module.exports = __webpack_public_path__ + "static/q5-06736448b70f09ac73b3d1b74c892519.svg";